import { FC } from "react";
import "../CSS/DashboardScreenDetailFooter.css";
import rsvpClockIcon from "../../../assets/images/dashboard-rsvp-clock-icon.svg";
import rsvpCalendarIcon from "../../../assets/images/dashboard-rsvp-calendar-icon.svg";
import rsvpButtonIcon from "../../../assets/images/dashboard-rsvp-button-icon.svg";
import dayjs from "dayjs";
import { DATE_FORMAT } from "utils/constants";
import { getWorkspaceSlotTime } from "utils/utils";

interface DashboardScreenDetailFooterProps {
  slotDate: string;
  slotTime: string;
  onClickRSVP: () => void;
}

const DashboardScreenDetailFooter: FC<DashboardScreenDetailFooterProps> = ({
  slotDate,
  slotTime,
  onClickRSVP,
}) => {
  return (
    <div className="dashboard-screen-bulletin-footer-container">
      <div className="detail-container">
        <div className="item-container">
          <img src={rsvpCalendarIcon} alt="calendar-icon" />
          {dayjs(slotDate).format(DATE_FORMAT)}
        </div>
        <div className="item-container">
          <img src={rsvpClockIcon} alt="clock-icon" />{" "}
          {getWorkspaceSlotTime(slotTime)}
        </div>
      </div>
      <div className="button-container" onClick={onClickRSVP}>
        RSVP
        <img src={rsvpButtonIcon} alt="rsvp-button" />
      </div>
      {/* <span>Exclusive for Member</span> */}
    </div>
  );
};

export default DashboardScreenDetailFooter;
